import React from "react";
import { FacetValue } from "../types";
import { toPascalCase } from "../batchStatusHelper";

interface BatchSummaryBarProps {
  title: string;
  facets: FacetValue[];
  colorMap: Record<string, string>;
  selectedValues: string[];
  onToggle: (value: string) => void;
}

function getColor(colorMap: Record<string, string>, value: string): string {
  return colorMap[value] || colorMap[value.toLowerCase()] || "#A19F9D";
}

export const BatchSummaryBar: React.FC<BatchSummaryBarProps> = ({ title, facets, colorMap, selectedValues, onToggle }) => {
  const total = facets.reduce((sum, f) => sum + f.count, 0);

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, color: "#323130" }}>{title}</div>
      <div style={{ display: "flex", height: 24, borderRadius: 4, overflow: "hidden", backgroundColor: "#F3F2F1" }}>
        {facets.map((facet) => {
          const widthPercent = total > 0 ? (facet.count / total) * 100 : 0;
          const isSelected = selectedValues.length === 0 || selectedValues.includes(facet.value);
          return (
            <div
              key={facet.value}
              onClick={() => onToggle(facet.value)}
              style={{
                width: `${widthPercent}%`,
                backgroundColor: getColor(colorMap, facet.value),
                opacity: isSelected ? 1 : 0.3,
                cursor: "pointer",
                transition: "opacity 0.2s",
                minWidth: widthPercent > 0 ? 4 : 0,
              }}
              title={`${toPascalCase(facet.value)}: ${facet.count}`}
            />
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 12, marginTop: 4, flexWrap: "wrap" }}>
        {facets.map((facet) => {
          const isSelected = selectedValues.length === 0 || selectedValues.includes(facet.value);
          return (
            <span
              key={facet.value}
              onClick={() => onToggle(facet.value)}
              style={{ fontSize: 12, cursor: "pointer", opacity: isSelected ? 1 : 0.5, display: "flex", alignItems: "center", gap: 4 }}
            >
              <span style={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: getColor(colorMap, facet.value), display: "inline-block" }} />
              {toPascalCase(facet.value)} ({facet.count})
            </span>
          );
        })}
      </div>
    </div>
  );
};
